import gql from 'graphql-tag';
import { pimCoreAssetFolderId } from '@/utils/config';
import { defaultApolloClient } from '@/vue-apollo';
import {
  getPimcoreFullPath,
  convertFileToBase64,
  parseCreateMessageId,
} from '@/utils/asset';
import { FileData } from '@/types/asset';

export default class AssetCrud {
  public static async getAsset(id: number): Promise<FileData|null> {
    const fileData: FileData = {
      fullpath: '',
      thumbnail: '',
      mimetype: '',
      filename: '',
    };
    try {
      if (!id) {
        throw new Error('неверный параметр id');
      }
      const query = gql`
        query GetAsset($id: Int!) {
          getAsset(id: $id) {
            id
            fullpath
            thumbnail: fullpath(thumbnail: "preview")
            mimetype
          }
        }
      `;
      const result = await defaultApolloClient.query({
        query,
        variables: {
          id,
        },
      });
      const asset = result?.data?.getAsset;
      asset.fullpath = getPimcoreFullPath(asset?.fullpath);
      asset.thumbnail = getPimcoreFullPath(asset?.thumbnail);
      return Object.assign(fileData, asset);
    } catch (e) {
      return null;
    }
  }

  public static async createAsset(file: File): Promise<number|null> {
    const fileBase64 = await convertFileToBase64(file);

    if (!fileBase64) {
      return null;
    }

    const mutation = gql`
      mutation CreateAsset($filename: String!, $parentId: Int, $type: String!, $input: AssetInput) {
        createAsset(filename: $filename, parentId: $parentId, type: $type, input: $input) {
          success
          message
        }
      }
    `;
    const datetime = (new Date()).getTime();
    const variables = {
      filename: file.name,
      parentId: pimCoreAssetFolderId,
      type: fileBase64.type,
      input: {
        filename: `${datetime}-${file.name}`,
        parentId: pimCoreAssetFolderId,
        data: fileBase64.content,
      },
    };

    const result = await defaultApolloClient.mutate({
      mutation,
      variables,
    });
    const id = parseCreateMessageId(result?.data?.createAsset?.message);
    return id;
  }
}
